import {
  Box, DashboardModule, Link,
} from '@domain-group/suit-theme'

import type { TaskListItemModel } from '@domain-group/realhub-backend-api-types'

import useRequestedChanges from '@hooks/useRequestedChanges'

import RequestedChange from './RequestedChange'

interface RequestedChangesProps {
  taskListItem: TaskListItemModel,
}

const RequestedChanges = (props: RequestedChangesProps) => {
  const { taskListItem } = props

  const requestedChangesPayload = useRequestedChanges(taskListItem)
  const {
    callbacks: {
      viewRequestedChanges,
    },
    tags,
  } = requestedChangesPayload

  if (!tags.length){
    return null
  }

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={(
        <Link onClick={viewRequestedChanges} textProps={{ fontSize: 'small' }}>
          View Tags
        </Link>
      )}
      title="Requested Changes"
    >
      <Box flexDirection="column">
        {tags.map(tag => (
          <RequestedChange key={tag.id} tag={tag} />
        ))}
      </Box>
    </DashboardModule>
  )
}

export default RequestedChanges
